import React from 'react';
import { Button, Header, Form, Icon, Tab } from 'semantic-ui-react';
import Details from './homepage/details';
import Images from './homepage/images';
import Messages from '../Messages.js';
import { languages } from '../../constants';

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange };
    return {
      menuItem: language.label,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  panes.push({
    menuItem: 'Gestion des images',
    render: () => (
      <Tab.Pane attached={false}>
        <Images obj={obj} onChange={onChange} />
      </Tab.Pane>
    ),
  });

  return panes;
};

const HomepageForm = ({ obj, status, onChange, onSubmit }) => {
  return (
    <Form>
      <Header as="h1">Page d'accueil : Edition</Header>
      <Messages errors={status.errors} messages={status.messages} />
      <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />
      <br />
      <br />
      <Form.Field>
        {status.loading ? (
          <Button type="submit" floated="left" color="red" loading>
            {' '}
            Chargement...
          </Button>
        ) : (
          <Button type="submit" floated="left" color="olive" onClick={onSubmit}>
            <Icon name="save" /> Sauvegarder
          </Button>
        )}
      </Form.Field>
    </Form>
  );
};

export default HomepageForm;



// WEBPACK FOOTER //
// ./src/components/form/Homepage.js